import {} from 'react-native';
import React from 'react';

const PickerView = () => {
  return <></>;
};

export default PickerView;
